import { t } from "@redotech/redo-i18n";
import { FlowTranslatableFieldSpec } from "./translation-save-diff";

/**
 * `field` must match the registry's declared names in flow-element-id-spec.ts;
 * a mismatch silently resolves to no translation in the portal.
 */
export const promptFieldSpec = (source: string): FlowTranslatableFieldSpec => ({
  field: "message",
  kind: "text",
  multiline: true,
  label: t("Prompt"),
  source,
});

export const descriptionFieldSpec = (
  source: string,
): FlowTranslatableFieldSpec => ({
  field: "description",
  kind: "html",
  label: t("Description"),
  source,
});

export const optionNameFieldSpec = (
  index: number,
  source: string,
): FlowTranslatableFieldSpec => ({
  field: "name",
  kind: "text",
  label: t("Option {{number}}", { number: index + 1 }),
  source,
});

export const headerFieldSpec = (source: string): FlowTranslatableFieldSpec => ({
  field: "header",
  kind: "text",
  label: t("Title"),
  source,
});

/** Information / Reject / Block customer message; html so the modal uses the rich editor. */
export const htmlMessageFieldSpec = (
  source: string,
): FlowTranslatableFieldSpec => ({
  field: "message",
  kind: "html",
  label: t("Message"),
  source,
});

export const continueButtonTextFieldSpec = (
  source: string,
): FlowTranslatableFieldSpec => ({
  field: "continueButtonText",
  kind: "text",
  label: t("Continue Button Text"),
  source,
});

export const customRegexErrorMessageFieldSpec = (
  source: string,
): FlowTranslatableFieldSpec => ({
  field: "customRegexErrorMessage",
  kind: "text",
  label: t("Validation error message"),
  source,
});

export const customQuestionFieldSpec = (
  source: string,
): FlowTranslatableFieldSpec => ({
  field: "customQuestion",
  kind: "text",
  multiline: true,
  label: t("Custom question (optional)"),
  source,
});

export const customExplanationSubtextFieldSpec = (
  source: string,
): FlowTranslatableFieldSpec => ({
  field: "customExplanationSubtext",
  kind: "text",
  multiline: true,
  label: t("Custom explanation subtext (optional)"),
  source,
});
